/* Black Month 2026 slideshow: scroll-snap carousel with buttons, dots, keys and optional (paused-on-interaction) autoplay. */
(function () {
  function init(root) {
    if (root.dataset.bmReady) return; root.dataset.bmReady = '1';
    var track = root.querySelector('[data-bm-track]'); if (!track) return;
    var slides = track.children, dots = root.querySelectorAll('[data-bm-dot]'), cur = 0, timer = null, hold = false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }
    function sync() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === cur) return; cur = i;
      dots.forEach(function (d, j) { if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    var raf = 0; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    var p = root.querySelector('[data-bm-prev]'), n = root.querySelector('[data-bm-next]');
    if (p) p.addEventListener('click', function () { go(cur - 1); });
    if (n) n.addEventListener('click', function () { go(cur + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.bmDot); }); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
    if (root.dataset.autoplay === 'true' && !reduce && slides.length > 1) {
      var ms = Math.max(6, +root.dataset.interval || 7) * 1000;
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { root.addEventListener(ev, function () { hold = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { root.addEventListener(ev, function () { hold = false; }); });
      timer = setInterval(function () { if (!hold && !document.hidden) go(cur + 1); }, ms);
    }
  }
  function all() { document.querySelectorAll('[data-bm-ss]').forEach(init); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();

/* Black Month 2026 phases: attributes that CSS cannot switch (slideshow aria-label, slide-1 image alt) follow <html data-bm-phase>. */
(function () {
  function fix() {
    var p = document.documentElement.getAttribute('data-bm-phase') || 'bm';
    if (p === 'bm') return;
    document.querySelectorAll('[data-bm-l-' + p + ']').forEach(function (el) { el.setAttribute('aria-label', el.getAttribute('data-bm-l-' + p)); });
    document.querySelectorAll('.bm-ss__slide').forEach(function (s) {
      var h = s.querySelector('.bm-ss__copy[data-bm-p="' + p + '"] .bm-ss__h'), img = s.querySelector('.bm-ss__img');
      if (h && img) img.setAttribute('alt', h.textContent.trim());
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
  document.addEventListener('shopify:section:load', fix);
})();
